import { Box, Chip, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

// TODO: cleanup with cp_annotation_createproject_agent ff

interface AttributeChipsProps {
  labels: string[];
  /** Shown when there are no labels; defaults to "None". */
  emptyLabel?: string;
}

/** Read-only step 2 attribute labels, in the step 2 grey chip style. */
export const AttributeChips = ({ labels, emptyLabel }: AttributeChipsProps) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();

  if (labels.length === 0) {
    return (
      <Typography variant="body2">
        {emptyLabel ??
          formatMessage({ id: 'createProjectWizard.step.annotationAgent.concept.none' })}
      </Typography>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: theme.spacing(2) }}>
      {labels.map((label) => (
        <Chip
          key={label}
          label={label}
          variant="outlined"
          size="small"
          sx={{ backgroundColor: theme.palette.grey[200], border: 0 }}
        />
      ))}
    </Box>
  );
};
